import mixpanel from 'mixpanel-browser'
import { Helper } from './helper'

export const MixPanel = {
  data() {
    return {
      envSource: {
        development: 'dev',
        staging: 'release',
        production: 'production',
      },
    }
  },
  methods: {
    // Function for call MixPanel Function
    track(title, props) {
      mixpanel.track(title, props)
    },
    register(props) {
      mixpanel.register(props)
    },
    unRegister(props) {
      mixpanel.unregister(props)
    },
    identify(uid) {
      mixpanel.identify(uid)
    },
    peopleSet(props) {
      mixpanel.people.set(props)
    },
    peopleIncrement(page) {
      mixpanel.people.increment(page)
    },
    addGroup(props, name) {
      mixpanel.add_group(props, name)
    },
    setGroup(props, name) {
      mixpanel.set_group(props, name)
    },
    getGroupSet(props, name) {
      mixpanel.get_group(props, name).set({
        $name: name,
      })
    },
    reset() {
      mixpanel.reset()
    },

    // Function for sending data to MixPanel
    actionAfterLogin(token, env, email) {
      var companyName = Helper.methods.getCompanyNameFromToken(token)
      var userName = Helper.methods.getUserNameFromToken(token)
      var userId = Helper.methods.getUserIdFromToken(token)
      var accessRight = Helper.methods.getAccessFromToken(token)

      // Registering Super Property to MixPanel (This property can be used in all pages)
      MixPanel.methods.register({
        env: MixPanel.data().envSource[env],
        App: 'vsms',
        'App Platform': 'web',
        'Access Rights': accessRight,
      })

      // Set unique id for user if null it will be auto generated to UUID
      MixPanel.methods.identify(`vsms.${companyName}.${userId}`)
      // Set user properties
      MixPanel.methods.peopleSet({
        'Company Name': companyName,
        $name: userName,
        $email: email,
        'User Id': userId,
      })

      // Set Group as Company name and set the user to the group
      MixPanel.methods.setGroup('company_name', companyName)
      MixPanel.methods.getGroupSet('company_name', companyName)

      // Track the action for this case used for sign in
      MixPanel.methods.track('Sign In')
    },

    actionAfterLoginIdentity() {
      const companyName = Helper.methods.getCompanyName()
      const userName = Helper.methods.getUserName()
      const userId = Helper.methods.getUserId()
      const accessRight = Helper.methods.getAccess()
      const email = Helper.methods.getUserEmail()

      // Registering Super Property to MixPanel (This property can be used in all pages)
      MixPanel.methods.register({
        env: MixPanel.data().envSource[process.env.VUE_APP_ENV],
        App: 'vsms',
        'App Platform': 'web',
        'Access Rights': accessRight,
      })

      // Set unique id for user if null it will be auto generated to UUID
      MixPanel.methods.identify(`vsms.${companyName}.${userId}`)
      // Set user properties
      MixPanel.methods.peopleSet({
        'Company Name': companyName,
        $name: userName,
        $email: email,
        'User Id': userId,
      })

      // Set Group as Company name and set the user to the group
      MixPanel.methods.setGroup('company_name', companyName)
      MixPanel.methods.getGroupSet('company_name', companyName)
    },

    actionResetPassword(env, companyName, fullname, email, accessRight, uuid) {
      MixPanel.methods.register({
        env: MixPanel.data().envSource[env],
        App: 'vsms',
        'App Platform': 'web',
        'Access Rights': accessRight,
      })

      // Set unique id for user if null it will be auto generated to UUID
      MixPanel.methods.identify(`vsms.${companyName}.${uuid}`)
      // Set user properties
      MixPanel.methods.peopleSet({
        'Company Name': companyName,
        $name: fullname,
        $email: email,
        'User Id': uuid,
      })

      // Set Group as Company name and set the user to the group
      MixPanel.methods.setGroup('company_name', companyName)
      MixPanel.methods.getGroupSet('company_name', companyName)

      // Track the action for this case used for sign in
      MixPanel.methods.track('Reset Password')
    },

    trackDownloadReport(report, extension, contact) {
      let titleMixpanel = ''
      let fileType = ''
      if (extension === 'pdf') {
        titleMixpanel = 'PDF'
        fileType = 'pdf'
      } else if (extension === 'xlsx') {
        titleMixpanel = 'Excel'
        fileType = 'excel'
      } else if (extension === 'csv') {
        titleMixpanel = 'CSV'
        fileType = 'csv'
      } else if (extension === 'graph') {
        titleMixpanel = 'Chart PDF'
        fileType = 'graph'
      }
      let desc = 'Download'
      if (contact) {
        desc = 'Share'
      }
      desc += ` ${report.event} - ${titleMixpanel}`
      this.track(desc)
      return fileType
    },
  },
}
